export const normalizeText = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export const findElementByText = (selector, predicate, root = document) =>
  Array.from(root.querySelectorAll(selector)).find((element) =>
    predicate(normalizeText(element.textContent)),
  );

export const replaceText = (element, value) => {
  if (element && element.textContent !== value) element.textContent = value;
};

export const setVisible = (element, visible) => {
  if (!element) return;
  const next = visible ? "" : "none";
  if (element.style.display !== next) element.style.display = next;
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number(value || 0));

export const parseCurrency = (value) => {
  const normalized = String(value || "")
    .replace(/[^\d,.-]/g, "")
    .replace(/\./g, "")
    .replace(/,/g, ".");
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};
